import { NgModule } from '@angular/core';
import { ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
  imports: [
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          // TODO we'll be used lazy loading when project will upgrade6.2 or above
          loader: (lng: string, ns: string) =>
            import(`../../../../public/i18n-assets/${lng}/${ns}.json`),
        },
        chunks: {
          commons: [
            'common',
            'pageMetaResolver',
            'spinner',
            'navigation',
            'searchBox',
            'sorting',
            'httpHandlers',
            'miniCart',
            'miniLogin',
            'skipLink',
            'formErrors',
            'errorHandlers',
            'chatMessaging',
            'button',
            'saved',
            'label',
            'knBrMessages',
            'toolTip',
            'myAccountPriceList',
            'atgPriceList',
            'httpHandlers',
          ],
          authMessages: ['authMessages'],
          userProfile: ['forgottenPassword', 'updateEmailForm'],
        },
        fallbackLang: 'en',
      },
    }),
  ],
})
export class KnBrI18nModule {}
